import { useState } from 'react';
import { Alert, Button, IconButton, Collapse, Typography, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

interface IncidentBannerProps {
  visible: boolean;
  message: string;
  details: string;
  severity: 'info' | 'warning' | 'error';
  onDismiss: () => void;
}

export function IncidentBanner({ visible, message, details, severity, onDismiss }: IncidentBannerProps) {
  const [expanded, setExpanded] = useState(false);

  if (!visible || !message) {
    return null;
  }

  return (
    <Alert
      severity={severity}
      variant="filled"
      sx={{ position: 'sticky', top: 0, zIndex: 1201, borderRadius: 0 }}
      action={
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {details && (
            <Button
              color="inherit"
              size="small"
              onClick={() => setExpanded(prev => !prev)}
              endIcon={expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            >
              More details
            </Button>
          )}
          <IconButton
            aria-label="Dismiss incident banner"
            color="inherit"
            size="small"
            onClick={onDismiss}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Box>
      }
    >
      <Box>
        <Typography variant="body2" component="span">
          {message}
        </Typography>
        {details && (
          <Collapse in={expanded}>
            <Typography variant="body2" sx={{ mt: 1, opacity: 0.9 }}>
              {details}
            </Typography>
          </Collapse>
        )}
      </Box>
    </Alert>
  );
}
